import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import kebabCase from 'lodash/kebabCase'
import slice from 'lodash/slice'
import { orderBy } from 'lodash'
import * as Collapsible from '@radix-ui/react-collapsible'
import { RowSpacingIcon, Cross2Icon } from '@radix-ui/react-icons'

const links = [
  { name: '帮助', url: '/help' },
  { name: '随机密码生成', url: '/random-password-generator/' },
  { name: '二维码生成', url: '/QRCode/' },
]

const Links = ({ links }) => {
  return links.map((link, i) => (
    <Link
      className="tag-outline-light text-center"
      key={`link-${i}`}
      to={link.url}
    >
      {link.name}
    </Link>
  ))
}

const Tags = ({ regions }) => {
  return regions.map(({ name, count }, i) => (
    <Link key={`tag-${i}`} className="tag" to={`/tags/${kebabCase(name)}/`}>
      {name} ({count})
    </Link>
  ))
}

const SideBar = () => {
  const data = useStaticQuery(graphql`
    query SideBarQuery {
      tags: allMarkdownRemark {
        group(field: { frontmatter: { tags: SELECT } }) {
          fieldValue
          totalCount
        }
      }
    }
  `)
  const [open, setOpen] = React.useState(false)
  const regions = orderBy(
    data.tags.group
      .map((x) => ({
        name: x.fieldValue,
        count: x.totalCount,
      }))
      .filter((x) => x.name !== '中国' && x.name !== ''),
    'count',
    'desc'
  )

  const count = 50
  const defaults = slice(regions, 0, count)
  const hiddens = slice(regions, count)
  return (
    <>
      <div className="sidebar">
        <Links links={links} />
      </div>
      <div className="sidebar">
        <div className="card-header">热门地区</div>

        <Collapsible.Root open={open} onOpenChange={setOpen}>
          <Tags regions={defaults} />
          <Collapsible.Content>
            <Tags regions={hiddens} />
          </Collapsible.Content>

          <div style={{ textAlign: 'right', marginTop: '0.5rem' }}>
            <Collapsible.Trigger asChild>
              <button className="icon-button">
                {open ? <Cross2Icon /> : <RowSpacingIcon />}
              </button>
            </Collapsible.Trigger>
          </div>
        </Collapsible.Root>
      </div>
    </>
  )
}

export default SideBar
